import React from "react";
import WestIndiesFlag from "../../../../../../public/assets/icons";

interface CricketFlagProps {
  isoCode?: string;
  className?: string;
  title?: string;
}

const CricketFlag: React.FC<CricketFlagProps> = ({
  isoCode,
  className = "",
  title = "",
}) => {
  if (!isoCode) return null;

  if (isoCode.toUpperCase() === "WI") {
    return <WestIndiesFlag className={`${className} inline-block`} />;
  }

  return (
    <span
      className={`fi fi-${isoCode.toLowerCase()} ${className}`}
      title={title}
    />
  );
};

export default CricketFlag;
